import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { OrganizationForm } from '@/features/admin/organizations/components/organization-form'
import { useCreateAdminOrganization } from '@/features/admin/organizations/hooks/use-create-admin-organization'
import { AdminPageHeader } from '@/features/admin/layout/admin-page-header'
import { router } from '@/router'

export const Route = createFileRoute('/admin/organizations/create')({
  component: AdminOrganizationCreatePage,
})

function AdminOrganizationCreatePage() {
  const { t } = useTranslation('admin')
  const { mutate, isPending } = useCreateAdminOrganization()

  return (
    <div className="space-y-4">
      <AdminPageHeader
        title={t('organizations.create.title')}
        subtitle={t('organizations.create.subtitle')}
      />
      <div className="mx-auto max-w-3xl">
        <OrganizationForm
          isSubmitting={isPending}
          onSubmit={(data) => mutate(data)}
          onCancel={() => router.navigate({ to: '/admin/organizations' })}
          submitLabel={t('organizations.create.submit')}
        />
      </div>
    </div>
  )
}
